import { render, staticRenderFns } from "./receivementview.vue?vue&type=template&id=5be775fc&scoped=true&"
import script from "./receivementview.vue?vue&type=script&lang=js&"
export * from "./receivementview.vue?vue&type=script&lang=js&"
import style0 from "./receivementview.vue?vue&type=style&index=0&id=5be775fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be775fc",
  null
  
)

export default component.exports